import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;

export const Start = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;

export const End = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;
